/**
 * useConfigReporte · hook + tipo compartido para encabezado/pie de reportes.
 * Tabla `config_reporte` (single row). Se lee 1 vez y cachea en memoria.
 */

import { useEffect, useState } from 'react'
import { supabase } from '@/lib/supabase'

export type ConfigReporte = {
  razon_social: string
  nombre_comercial: string | null
  nit: string
  direccion_fiscal: string
  telefono: string | null
  email: string | null
  perito_contador_nombre: string | null
  perito_contador_nit: string | null
  representante_legal_nombre: string | null
  resolucion_igc: string | null
  resolucion_sat: string | null
  pie_legal: string | null
  logo_url: string | null
}

let cache: ConfigReporte | null = null

export async function fetchConfigReporte(): Promise<ConfigReporte | null> {
  if (cache) return cache
  const { data, error } = await supabase.from('config_reporte').select('*').eq('id', 1).maybeSingle()
  if (error || !data) return null
  cache = data as ConfigReporte
  return cache
}

export function invalidateConfigReporte() {
  cache = null
}

export function useConfigReporte() {
  const [config, setConfig] = useState<ConfigReporte | null>(cache)
  const [loading, setLoading] = useState(!cache)

  useEffect(() => {
    if (cache) return
    fetchConfigReporte().then((c) => {
      setConfig(c)
      setLoading(false)
    })
  }, [])

  return { config, loading }
}
